import React from 'react';
import { Alert, Button } from 'antd';
import { InfoIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const KEY_PREFIX = 'corporateAccounts.wallet.dashboard.bankTransferReminder';

// Shown once the customer has taken our bank details away but has not yet told us what they sent.
// `onConfirm` reopens the flow straight at step 2.
const BankTransferReminder = ({ onConfirm, onClose }) => {
  const { translateText } = useTranslation();

  return (
    <Alert
      type="info"
      closable
      onClose={onClose}
      className={styles.bankTransferReminder}
      icon={<InfoIcon />}
      showIcon
      data-testid="walletBankTransferReminder"
      message={
        <span className={styles.bankTransferReminderTitle}>
          {translateText(`${KEY_PREFIX}.title`)}
        </span>
      }
      description={translateText(`${KEY_PREFIX}.description`)}
      action={
        <Button
          type="primary"
          className={styles.bankTransferReminderCta}
          onClick={onConfirm}
          data-testid="walletBankTransferReminderConfirm"
        >
          {translateText(`${KEY_PREFIX}.confirm`)}
        </Button>
      }
    />
  );
};

export default BankTransferReminder;
